module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30826",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.5073",
      "atom": "static-1.5441",
      "client-types": "static-1.501",
      "conversations-error-reporting": "static-1.9239",
      "conversations-internal-pub-sub": "static-1.16355",
      "conversations-internal-schema": "static-1.13464",
      "conversations-message-history": "static-1.13641",
      "conversations-test-sdk": "static-1.10853",
      "conversations-visitor-experience-components": "static-1.24189",
      "data-fetching-client": "static-1.10010",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5950",
      "hs-test-utils": "static-1.8397",
      "hubspot-dlb": "static-2.1911",
      "HubStyleTokens": "static-2.11851",
      "I18n": "static-7.1681",
      "immer": "static-1.102",
      "jasmine-immutable": "static-1.3369",
      "jasmine-runner": "static-1.6809",
      "quartz": "static-1.7528",
      "react-dlb": "static-1.90",
      "react-select-plus": "static-1.114",
      "react-transition-group": "static-2.74",
      "redux-thunk": "static-2.81",
      "reselect": "static-3.13",
      "sanitize": "static-1.4831",
      "StyleGuideUI": "static-3.509",
      "transmute": "static-2.97",
      "urlinator": "static-1.4877",
      "usage-tracker": "static-1.7673",
      "usage-tracker-core": "static-1.7523",
      "usage-tracker-public": "static-1.7484",
      "viral-links-lib": "static-1.7435",
      "visitor-ui-component-library": "static-1.6515",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5173",
      "conversations-visitor-message-history": "static-1.22926",
      "cssUtils": "static-1.983",
      "enviro": "static-4.455",
      "flux-actions": "static-1.375",
      "foundations-components": "static-1.8574",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6572",
      "interactive-cards": "static-1.434",
      "hubspot-url-utils": "static-1.4383",
      "immutable": "static-2.88",
      "metrics-js": "static-1.9990",
      "PatternValidationJS": "static-1.3251",
      "PortalIdParser": "static-2.404",
      "pulse": "static-1.992",
      "raven": "static-3.5925",
      "react": "static-7.199",
      "react-aria": "static-1.73",
      "react-dom": "static-7.85",
      "react-redux": "static-7.80",
      "react-rhumb": "static-1.17086",
      "react-utils": "static-2.5593",
      "redux": "static-4.81",
      "rpc-client-utils": "static-1.5025",
      "redux-toolkit": "static-1.79",
      "sanitize-text": "static-1.8518",
      "signup-constants": "static-1.19716",
      "styled-components": "static-2.100",
      "usage-tracker-multi": "static-1.6087",
      "visitor-ui-component-library-icons": "static-1.6326",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "moment": "static-3.75",
      "quartz-config": "static-1.1306",
      "quartz-core": "static-1.6747",
      "foundations-assets": "static-1.5246",
      "foundations-theming": "static-1.4839",
      "UIComponents": "static-3.8797",
      "conversations-async-data": "static-2.8022",
      "customer-data-email": "static-1.18585",
      "cv-backend-services": "static-1.1597",
      "immutable-less": "static-1.5010",
      "conversations-skeleton-state": "static-1.7596",
      "crm-events-viz-core": "static-1.34213",
      "customer-data-objects": "static-1.8049",
      "icons": "static-2.695",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.914",
      "ui-images": "static-2.1265",
      "apollo-stack-hubspot": "static-3.95",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.90",
      "HeadJS": "static-2.805",
      "framer-motion": "static-1.80",
      "hs-test-utils-bend-plugin": "static-1.3508",
      "msw": "static-1.39",
      "msw-config": "static-1.9",
      "testing-library": "static-1.160",
      "i18n-data": "static-1.230",
      "moment-timezone": "static-5.92",
      "jasmine": "static-4.4672",
      "signup-ui-url-generator": "static-2.8419",
      "quartz-i18n": "static-1.1203",
      "sassPrefix": "static-1.250",
      "bend-plugin-foundations-components": "static-1.4843",
      "floating-ui": "static-1.64",
      "foundations-theming-specialty": "static-1.2555",
      "hs-story-utils": "static-1.9785",
      "react-create-root-preference": "static-1.80",
      "react-virtualized": "static-2.108",
      "tanstack-table": "static-1.62",
      "trellis-assets": "static-1.2795",
      "ui-fonts": "static-1.1113",
      "hs-locale-management": "static-1.331",
      "dompurify": "static-1.9",
      "utility-belt": "static-1.2893",
      "bend-plugin-pulse": "static-1.495",
      "batch-promise": "static-1.1905",
      "chirp-fetch": "static-1.2257",
      "event-emitter": "static-1.1318",
      "fast-json-patch": "static-1.71",
      "hub-http-janus": "static-1.889",
      "quick-fetch": "static-1.4159",
      "csstype": "static-1.50",
      "quartz-head": "static-1.1193",
      "web-vitals": "static-1.16",
      "bend-plugin-chirp-manifest": "static-1.435",
      "quartz-routing": "static-1.958",
      "usage-tracker-anonymous": "static-1.6090",
      "opentelemetry-fe-types": "static-1.142",
      "dispatcher": "static-1.144",
      "general-store": "static-6.20",
      "hubspotter-http": "static-1.4895",
      "mobile-manifest-mixins": "static-1.585",
      "module-federation": "static-1.34",
      "opentelemetry-fe": "static-1.517",
      "quartz-auth": "static-1.1203",
      "quartz-test": "static-1.1203",
      "quartz-tracking": "static-1.907",
      "trellis-components": "static-1.2814",
      "usage-tracker-container": "static-1.7663",
      "bend-plugin-foundations-theming": "static-1.3322",
      "foundations-theming-base": "static-1.3824",
      "stylex": "static-1.42",
      "HubStyle": "static-2.12158",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.5007",
      "customer-data-ui-utilities": "static-1.10191",
      "FileManagerCore": "static-1.40119",
      "FileManagerLib": "static-1.40260",
      "hubspot-apollo-client": "static-1.5235",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.622",
      "timezone-utils": "static-2.5592",
      "ui-gdpr-components": "static-1.10646",
      "ts-schema": "static-1.4330",
      "ai-components-ui-library": "static-1.9831",
      "avatar-components": "static-1.2844",
      "content-assistance-lib": "static-1.8274",
      "crm-component-utils": "static-1.39950",
      "crm-display-components": "static-1.25700",
      "crm-fe-perf": "static-1.23258",
      "crm-links": "static-1.6660",
      "crm-message-bus": "static-1.43875",
      "crm-search-service-types": "static-1.1496",
      "crm-source-interpretation-lib": "static-1.5692",
      "customer-data-communicator": "static-1.46452",
      "customer-data-filters-ui": "static-1.41082",
      "customer-data-objects-ui-components": "static-1.13391",
      "customer-data-properties": "static-1.52753",
      "customer-data-rte": "static-1.33723",
      "draft-plugins": "static-2.22222",
      "file-manager-components": "static-1.24620",
      "trellis-theming": "static-1.1335",
      "framework-data-schema-resolvers": "static-1.7254",
      "frontend-preferences-client": "static-1.8281",
      "hubspot-prosemirror": "static-1.19083",
      "object-comments-thread-lib": "static-1.11428",
      "prosemirror-user-and-team-at-mentions": "static-1.1288",
      "reference-resolvers-lite": "static-1.8463",
      "ui-addon-upgrades": "static-9.18453",
      "universal-associations-select": "static-1.11439",
      "universal-record-utils-lib": "static-1.2116",
      "wootric-nps": "static-1.7232",
      "inbound-db-properties-service-client": "static-1.4083",
      "property-translator": "static-1.5742",
      "segments-query-core": "static-1.1785",
      "bender-build-tools": "static-1.3452",
      "stylex-utils": "static-1.149",
      "opentelemetry-web": "static-1.15",
      "beacon-keepalive-queue": "static-1.66",
      "hub-http-shared-msw-handlers": "static-1.10710",
      "hubspotter-http-shared-msw-handlers": "static-1.10708",
      "usage-tracker-session-replay": "static-1.5359",
      "base-ui": "static-1.23",
      "react-day-picker": "static-1.11",
      "tanstack-virtual": "static-1.39",
      "react-dnd-compat": "static-1.4975",
      "breeze-artifacts-sdk": "static-1.539",
      "copilot-toolkit": "static-1.11943",
      "audio-components": "static-1.6421",
      "ContentUtils": "static-1.69237",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29889",
      "FileManagerImages": "static-1.37771",
      "foundations-components-legacy": "static-1.1599",
      "html-to-image": "static-1.62",
      "immerable": "static-1.4505",
      "react-colorpicker": "static-2.10575",
      "ui-universal-auth": "static-1.9504",
      "video-components": "static-1.14244",
      "video-data-lib": "static-1.35900",
      "video-embed": "static-1.36734",
      "hubspot-apollo-cache": "static-1.694",
      "chatspot-core": "static-1.23302",
      "superstore": "static-1.5120",
      "ui-addon-video-player": "static-1.9052",
      "ui-coaching-tips": "static-1.29408",
      "card-properties-lib": "static-1.45116",
      "commerce-subscription-lib": "static-1.37892",
      "crm-actions": "static-1.6710",
      "crm-cards-sdk": "static-1.44720",
      "customer-data-properties-shared-msw-handlers": "static-1.10037",
      "customer-data-property-utils": "static-1.8448",
      "customer-data-tracking": "static-1.7230",
      "hs-resources": "static-1.553",
      "inbound-db-meta-service-client": "static-1.3718",
      "framework-data-table": "static-2.12649",
      "location-customization-utils-lib": "static-1.10212",
      "restore-request-side-panel-lib": "static-1.1784",
      "calling-error-reporting": "static-1.31689",
      "calling-internal-common": "static-1.31682",
      "calling-usage-tracker": "static-1.6896",
      "crm_data": "static-4.92962",
      "customer-data-content": "static-1.27869",
      "draft-content-plugins": "static-1.28979",
      "draft-convert": "static-2.81",
      "draft-extend": "static-3.84",
      "draft-js": "static-5.86",
      "draft-signature-plugin": "static-1.24794",
      "EmailSignatureEditor": "static-1.25073",
      "hubspot-prosemirror-plugins": "static-1.19075",
      "integration-settings-components": "static-1.16306",
      "integrations-lib": "static-1.17180",
      "integrations-tracking-lib": "static-1.5971",
      "laboratory-lib": "static-3.7513",
      "native-integrations-shared-strings": "static-1.8126",
      "nav-meta": "static-1.30572",
      "onboarding-scopes": "static-1.6813",
      "outreach-assistant-email-generation": "static-1.6896",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12409",
      "quotes-client-types": "static-1.38970",
      "reference-resolvers": "static-1.8542",
      "rich-text-lib": "static-1.20389",
      "sales-email-signature-service-client": "static-1.4208",
      "sequences-lib": "static-1.8607",
      "ui-addon-i18n": "static-1.11508",
      "ui-addon-iframeable": "static-1.9438",
      "ui-business-units-lib": "static-1.9452",
      "ui-shepherd-react": "static-3.10632",
      "user-context": "static-1.5471",
      "whatsapp-sending-lib": "static-1.6882",
      "customer-data-filters-ui-msw-helpers": "static-1.23517",
      "customer-data-reference-ui-components": "static-1.13529",
      "events-data-lib": "static-1.608",
      "FormUrlGenerator": "static-2.5075",
      "framework-builder-read-service-client": "static-1.4258",
      "multi-account-reference-resolvers": "static-1.1367",
      "onboarding-tours": "static-1.17215",
      "reporting-datasets-permissions-lib": "static-1.14561",
      "segments-client-types": "static-1.11740",
      "SharedI18nStrings": "static-1.184",
      "ui-addon-teams": "static-1.21963",
      "calling-global-api": "static-1.65812",
      "calling-lifecycle-internal": "static-1.67194",
      "calling-lifecycle-messages": "static-1.59488",
      "commerce-products-lib": "static-1.10656",
      "conditional-properties-service-client": "static-1.4053",
      "crm-index-visualization-core": "static-1.4607",
      "crm-pipelines-api-client-types": "static-1.4384",
      "external-options-client-types": "static-1.4377",
      "formula-editor": "static-1.14855",
      "google-libphonenumber": "static-1.46",
      "inbounddb-objects-service-types": "static-1.4461",
      "meetings-icalendar-utils-lib": "static-1.995",
      "multi-currency-client-types": "static-1.3944",
      "object-builder-ui-client": "static-1.49801",
      "pipeline-validation-client-types": "static-1.4219",
      "property-value-citations": "static-1.3367",
      "smart-data-capture-core": "static-1.233",
      "smart-property-lib": "static-1.8414",
      "tiered-pricing": "static-1.2048",
      "topics-actions-lib": "static-1.531",
      "trial-components-library": "static-1.14200",
      "ui-addon-form-validation": "static-1.11332",
      "zustand": "static-1.86",
      "breeze-engine-lib": "static-1.1882",
      "video-components-external": "static-1.12242",
      "fdsr-migration-layer": "static-1.373",
      "framework-data-schema-quick-fetch": "static-1.7159",
      "persist-promise": "static-1.4062",
      "content-media-capture": "static-1.5560",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.26291",
      "knowledge-content-types": "static-1.8699",
      "payment-link-components": "static-1.24246",
      "ui-addon-emoji-picker": "static-1.10231",
      "call-summary": "static-1.40502",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10856",
      "merchandise-lib": "static-1.279",
      "purchase-motions-components": "static-1.6487",
      "crm-object-search-query-utilities": "static-1.10285",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "magpie-lib": "static-1.5799",
      "magpie-types": "static-1.5259",
      "simple-logging-lib": "static-1.3410",
      "cms-field-types": "static-1.5171",
      "content-icons-ui": "static-1.2410",
      "underscore": "static-1.8",
      "nudge-client-utils": "static-1.3230",
      "unified-auth-core-lib": "static-1.1300",
      "social-insights-client-types": "static-1.22729",
      "outpost": "static-1.4500",
      "markdown-it": "static-1.6",
      "growth-onboarding-feedback-components": "static-1.6946",
      "customer-data-sidebar": "static-2.46833",
      "enrichment-lib": "static-1.617",
      "ui-addon-draggable-compat": "static-2.4623",
      "commerce-billing-lib": "static-1.20317",
      "commerce-shared-components-lib": "static-1.19374",
      "commerce-tools-ui-lib": "static-1.11142",
      "customer-data-associations": "static-1.7690",
      "tasks-actions-lib": "static-1.240",
      "reporting-data": "static-1.68997",
      "ui-addon-draggable": "static-3.5107",
      "crm-record-cards-service-types": "static-1.3803",
      "crm_universal": "static-1.22556",
      "SalesContentIndexUI": "static-3.9675",
      "content-embed-lib": "static-1.7699",
      "data-model-builder-lib": "static-1.13280",
      "remote-dom": "static-1.5",
      "remote-ui": "static-1.72",
      "ui-components-test-utils": "static-1.5988",
      "ui-extensions-remote-renderer": "static-1.17989",
      "universal-page-editor-lib": "static-1.3371",
      "integrations-error-boundary-lib": "static-1.14595",
      "redux-observable": "static-1.76",
      "ReduxMessenger": "static-2.10732",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.1018",
      "ai-addon-copilot-preview": "static-1.9043",
      "data-token-picker": "static-1.16965",
      "sequences-client-types-lib": "static-1.8464",
      "foundations-components-test-utils": "static-1.6057",
      "navigation-messaging": "static-1.8262",
      "getting-started-shared-tasks": "static-1.19350",
      "getting-started-shared-tasks-store": "static-1.18468",
      "onboarding-tours-utils": "static-1.1282",
      "messaging-usage-based-billing-components-lib": "static-1.2123",
      "marketing-platform-lib": "static-1.7233",
      "whatsapp-management-lib": "static-1.10041",
      "growth-data-modal": "static-1.5971",
      "growth-onboarding-confetti": "static-1.3425",
      "growth-onboarding-next-action-utils": "static-1.2788",
      "navigation-components": "static-1.18935",
      "onboarding-tours-client": "static-1.5430",
      "ui-shepherd-tracker": "static-1.8013",
      "crm-index-associations-lib": "static-1.6806",
      "shared-worker-versioning": "static-1.11401",
      "voice-sms-access-library": "static-1.2177",
      "commerce-permissions": "static-1.1137",
      "products-iframe-lib": "static-1.8688",
      "products-ui-components-shared-msw-handlers": "static-1.11092",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10793",
      "sales-views-client-types": "static-1.4616",
      "bark-lib": "static-1.16882",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.103",
      "crm-properties-common-lib": "static-1.6250",
      "react-codemirror": "static-1.11003",
      "data-agent-kit": "static-1.727",
      "fsm": "static-1.4114",
      "policy-lib": "static-1.7166",
      "embedded-academy-lib": "static-1.15689",
      "hubs-service-types": "static-1.1621",
      "purchase-motions-api": "static-1.6490",
      "breeze-engine-chat-components": "static-1.860",
      "breeze-engine-core": "static-1.1160",
      "highlight.js": "static-1.87",
      "content-media-composition-data-lib": "static-1.13364",
      "content-media-compositions": "static-2.17371",
      "idb-keyval": "static-1.52",
      "media-bridge-lib": "static-1.19481",
      "fix-webm-duration": "static-1.31",
      "notification-sounds": "static-1.4784",
      "seat-types-lib": "static-1.822",
      "ui-addon-opt": "static-4.8715",
      "commerce-tours-lib": "static-1.6703",
      "growth-onboarding-reliability": "static-1.5442",
      "sales-checkout-service-client": "static-1.3890",
      "calling-cross-tab-library": "static-1.19660",
      "calling-lifecycle-usage-tracker": "static-1.9476",
      "reactive-lib": "static-1.1079",
      "nudge-custom-function-registry": "static-1.2987",
      "nudge-renderer-utils": "static-1.3306",
      "whisper-core-api": "static-1.7429",
      "card-payment-highlight-lib": "static-1.38102",
      "commerce-contract-lib": "static-1.13513",
      "invoices-highlight-card-lib": "static-1.55915",
      "orders-highlight-card-lib": "static-1.22294",
      "products-highlight-card-lib": "static-1.18939",
      "quotes-highlight-card-lib": "static-1.72880",
      "data-agent-test-utils": "static-1.210",
      "data-agent-utils": "static-1.679",
      "usage-based-billing-components-lib": "static-1.10457",
      "payments-enrollment-embed-lib": "static-1.23975",
      "stripe-embedded-components": "static-1.8072",
      "growth-onboarding-empty-states": "static-1.6363",
      "InboxConnectUtils": "static-4.15653",
      "payments-post-enroll-local-storage-lib": "static-1.5464",
      "qrcode-generator": "static-1.77",
      "reporting-client-types": "static-1.2731",
      "react-flip-move": "static-1.79",
      "FireAlarmUi": "static-1.4756",
      "sales-templates-service-types-lib": "static-1.4421",
      "ui-asset-management-lib": "static-1.11464",
      "association-settings-lib": "static-1.11115",
      "collaboration-sidebar": "static-1.58828",
      "conditional-property-settings-components": "static-1.349",
      "conditional-property-settings-modal": "static-1.13260",
      "data-model-commons-lib": "static-1.13483",
      "ExportDialog": "static-6.10740",
      "final-form": "static-1.79",
      "property-management-iframe": "static-1.14240",
      "property-usages-lib": "static-1.5871",
      "reactflow": "static-1.72",
      "simple-data-table": "static-1.3613",
      "used-in-list-lib": "static-1.7328",
      "visual-association": "static-1.6255",
      "highcharts": "static-8.112",
      "reporting-visualizations": "static-1.61071",
      "ui-extensibility-client-types": "static-1.4277",
      "adobe-sign-auth-lib": "static-1.568",
      "ads-unified-auth-lib": "static-1.1580",
      "custom-vendor-connection-lib": "static-1.68",
      "google-sheets-integration-lib": "static-1.1130",
      "microsoft-drive-auth-lib": "static-1.268",
      "surveymonkey-integration-lib": "static-1.606",
      "slack-ui-library": "static-1.10758",
      "ai-rendering-library": "static-1.11199",
      "ai-settings-ui-library": "static-1.8419",
      "breeze-engine-ui-devtools": "static-1.256",
      "copilot-plugins": "static-1.11915",
      "messaging-shared-utils-lib": "static-1.1572",
      "messaging-user-info-utils-lib": "static-1.1742",
      "content-whatsapp-service-types": "static-1.584",
      "short-messages-app-service-client": "static-1.4283",
      "ui-tool-access": "static-1.10515",
      "onboarding-data-sync-lib": "static-1.2621",
      "growth-onboarding-next-action-components": "static-1.2816",
      "user-context-client": "static-1.4869",
      "nest": "static-1.596",
      "calling-orchestration-schema": "static-1.36954",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16460",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4867",
      "storybook-react": "static-1.41",
      "academy-common-lib": "static-1.15149",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.41174",
      "settings-ui-lib": "static-1.12883",
      "accounting-integrations-ui-components": "static-1.7616",
      "invoices-ui-lib": "static-1.55931",
      "commerce-products-api": "static-1.2758",
      "invoices-iframe-lib": "static-1.57989",
      "quotes-modal-lib": "static-1.103558",
      "quotes-ui-lib": "static-1.81601",
      "one-click-checkout": "static-1.538",
      "platform-infra-nav-components": "static-1.7931",
      "reporting-ui-components": "static-2.66266",
      "subscription-experience-data-types": "static-1.15302",
      "marketplace-ui-apps-core": "static-1.19377",
      "stripe-connect-js": "static-1.78",
      "ui-addon-react-router-dom": "static-1.9892",
      "hub-http-contrib": "static-1.3388",
      "ui-addon-sales-email": "static-1.5563",
      "nested-table": "static-1.596",
      "chatspot-widget-iframe": "static-1.23293",
      "collaboration-sidebar-common": "static-1.3625",
      "conditional-property-settings-data": "static-1.367",
      "property-management-common": "static-1.6528",
      "d3": "static-1.7",
      "breeze-onboarding-components": "static-1.839",
      "global-styles-ai-lib": "static-1.250",
      "marketplace-embed-ba": "static-1.719",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.42167",
      "reporting-snowflake": "static-1.57613",
      "upgrade-components-lib": "static-1.590",
      "ui-brand-identity-lib": "static-1.16676",
      "meetings-connect-utils-lib": "static-1.7971",
      "academy-service-client": "static-1.4052",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4754",
      "trellis-ecosystem": "static-1.7702",
      "commerce-tax-lib": "static-1.899",
      "price-books-api": "static-1.1830",
      "price-books-components": "static-1.1888",
      "property-description-translator": "static-1.4185",
      "ramp-editor": "static-1.982",
      "commerce-analytics-service-client": "static-1.3878",
      "totals-ui-components": "static-1.24384",
      "checkout-sdk": "static-3.24476",
      "payment-method-components": "static-1.7206",
      "touchless-buying-components": "static-1.6344",
      "upgrade-catalog-service-types": "static-1.3796",
      "reporting-plugins": "static-1.10834",
      "reporting-reports": "static-1.68673",
      "edison-service-client-types": "static-1.758",
      "developer-experience-shared-components": "static-1.10897",
      "marketplace-ui-client-types": "static-1.18252",
      "marketplace-ui-common": "static-1.20845",
      "ui-addon-integrations-directory-panel": "static-2.8377",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.508",
      "onboarding-journeys-lib": "static-1.1039",
      "marketplace-embed": "static-1.23016",
      "marketplace-ui-install": "static-1.831",
      "marketplace-ui-tracking": "static-1.15015",
      "dashboard-lib": "static-1.83003",
      "share-with-third-party-component-lib": "static-1.9070",
      "ContentData": "static-1.69312",
      "line-items-api": "static-1.1167",
      "commerce-totals-service-types": "static-1.4069",
      "hub-http-rxjs": "static-1.856",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4352",
      "company-details-components": "static-1.6567",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.16093",
      "quote-checkout-service-types": "static-1.3815",
      "campaign-roi-lib": "static-1.10508",
      "campaigns-utils-lib": "static-1.3588",
      "ui-addon-calendars": "static-2.5708",
      "apps-service-types": "static-1.4067",
      "oauth-service-types": "static-1.4594",
      "ui-product-approvals-common": "static-1.1261",
      "connections-embed-lib": "static-1.1589",
      "fail-safe": "static-1.317",
      "ai-studio-lib": "static-1.12523",
      "integrations-reconnect-lib": "static-1.562",
      "ui-product-approvals": "static-1.29366",
      "redux-actions": "static-3.71",
      "advanced-menus-core": "static-1.15650",
      "advanced-menus-lib": "static-1.12507",
      "ui-memberships-settings-lib": "static-1.34941",
      "company-details-service-types": "static-1.4303",
      "pricing-pages-api": "static-1.15958",
      "copilot-messaging": "static-1.2193",
      "bend-plugin-fail-safe": "static-1.268",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15649",
      "simple-menus-lib": "static-1.17166"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30826",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.5073",
      "atom": "/atom/static-1.5441",
      "client-types": "/client-types/static-1.501",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9239",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16355",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13464",
      "conversations-message-history": "/conversations-message-history/static-1.13641",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10853",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.24189",
      "data-fetching-client": "/data-fetching-client/static-1.10010",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5950",
      "hs-test-utils": "/hs-test-utils/static-1.8397",
      "hubspot-dlb": "/hubspot-dlb/static-2.1911",
      "HubStyleTokens": "/HubStyleTokens/static-2.11851",
      "I18n": "/I18n/static-7.1681",
      "immer": "/immer/static-1.102",
      "jasmine-immutable": "/jasmine-immutable/static-1.3369",
      "jasmine-runner": "/jasmine-runner/static-1.6809",
      "quartz": "/quartz/static-1.7528",
      "react-dlb": "/react-dlb/static-1.90",
      "react-select-plus": "/react-select-plus/static-1.114",
      "react-transition-group": "/react-transition-group/static-2.74",
      "redux-thunk": "/redux-thunk/static-2.81",
      "reselect": "/reselect/static-3.13",
      "sanitize": "/sanitize/static-1.4831",
      "StyleGuideUI": "/StyleGuideUI/static-3.509",
      "transmute": "/transmute/static-2.97",
      "urlinator": "/urlinator/static-1.4877",
      "usage-tracker": "/usage-tracker/static-1.7673",
      "usage-tracker-core": "/usage-tracker-core/static-1.7523",
      "usage-tracker-public": "/usage-tracker-public/static-1.7484",
      "viral-links-lib": "/viral-links-lib/static-1.7435",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6515",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5173",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22926",
      "cssUtils": "/cssUtils/static-1.983",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.375",
      "foundations-components": "/foundations-components/static-1.8574",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6572",
      "interactive-cards": "/interactive-cards/static-1.434",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
      "immutable": "/immutable/static-2.88",
      "metrics-js": "/metrics-js/static-1.9990",
      "PatternValidationJS": "/PatternValidationJS/static-1.3251",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "pulse": "/pulse/static-1.992",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.199",
      "react-aria": "/react-aria/static-1.73",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.80",
      "react-rhumb": "/react-rhumb/static-1.17086",
      "react-utils": "/react-utils/static-2.5593",
      "redux": "/redux/static-4.81",
      "rpc-client-utils": "/rpc-client-utils/static-1.5025",
      "redux-toolkit": "/redux-toolkit/static-1.79",
      "sanitize-text": "/sanitize-text/static-1.8518",
      "signup-constants": "/signup-constants/static-1.19716",
      "styled-components": "/styled-components/static-2.100",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6087",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6326",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "moment": "/moment/static-3.75",
      "quartz-config": "/quartz-config/static-1.1306",
      "quartz-core": "/quartz-core/static-1.6747",
      "foundations-assets": "/foundations-assets/static-1.5246",
      "foundations-theming": "/foundations-theming/static-1.4839",
      "UIComponents": "/UIComponents/static-3.8797",
      "conversations-async-data": "/conversations-async-data/static-2.8022",
      "customer-data-email": "/customer-data-email/static-1.18585",
      "cv-backend-services": "/cv-backend-services/static-1.1597",
      "immutable-less": "/immutable-less/static-1.5010",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7596",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.34213",
      "customer-data-objects": "/customer-data-objects/static-1.8049",
      "icons": "/icons/static-2.695",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.914",
      "ui-images": "/ui-images/static-2.1265",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.95",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.90",
      "HeadJS": "/HeadJS/static-2.805",
      "framer-motion": "/framer-motion/static-1.80",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3508",
      "msw": "/msw/static-1.39",
      "msw-config": "/msw-config/static-1.9",
      "testing-library": "/testing-library/static-1.160",
      "i18n-data": "/i18n-data/static-1.230",
      "moment-timezone": "/moment-timezone/static-5.92",
      "jasmine": "/jasmine/static-4.4672",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8419",
      "quartz-i18n": "/quartz-i18n/static-1.1203",
      "sassPrefix": "/sassPrefix/static-1.250",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4843",
      "floating-ui": "/floating-ui/static-1.64",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2555",
      "hs-story-utils": "/hs-story-utils/static-1.9785",
      "react-create-root-preference": "/react-create-root-preference/static-1.80",
      "react-virtualized": "/react-virtualized/static-2.108",
      "tanstack-table": "/tanstack-table/static-1.62",
      "trellis-assets": "/trellis-assets/static-1.2795",
      "ui-fonts": "/ui-fonts/static-1.1113",
      "hs-locale-management": "/hs-locale-management/static-1.331",
      "dompurify": "/dompurify/static-1.9",
      "utility-belt": "/utility-belt/static-1.2893",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.495",
      "batch-promise": "/batch-promise/static-1.1905",
      "chirp-fetch": "/chirp-fetch/static-1.2257",
      "event-emitter": "/event-emitter/static-1.1318",
      "fast-json-patch": "/fast-json-patch/static-1.71",
      "hub-http-janus": "/hub-http-janus/static-1.889",
      "quick-fetch": "/quick-fetch/static-1.4159",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.1193",
      "web-vitals": "/web-vitals/static-1.16",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.435",
      "quartz-routing": "/quartz-routing/static-1.958",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6090",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.142",
      "dispatcher": "/dispatcher/static-1.144",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http": "/hubspotter-http/static-1.4895",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
      "module-federation": "/module-federation/static-1.34",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.517",
      "quartz-auth": "/quartz-auth/static-1.1203",
      "quartz-test": "/quartz-test/static-1.1203",
      "quartz-tracking": "/quartz-tracking/static-1.907",
      "trellis-components": "/trellis-components/static-1.2814",
      "usage-tracker-container": "/usage-tracker-container/static-1.7663",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3322",
      "foundations-theming-base": "/foundations-theming-base/static-1.3824",
      "stylex": "/stylex/static-1.42",
      "HubStyle": "/HubStyle/static-2.12158",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5007",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10191",
      "FileManagerCore": "/FileManagerCore/static-1.40119",
      "FileManagerLib": "/FileManagerLib/static-1.40260",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5235",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.622",
      "timezone-utils": "/timezone-utils/static-2.5592",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10646",
      "ts-schema": "/ts-schema/static-1.4330",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9831",
      "avatar-components": "/avatar-components/static-1.2844",
      "content-assistance-lib": "/content-assistance-lib/static-1.8274",
      "crm-component-utils": "/crm-component-utils/static-1.39950",
      "crm-display-components": "/crm-display-components/static-1.25700",
      "crm-fe-perf": "/crm-fe-perf/static-1.23258",
      "crm-links": "/crm-links/static-1.6660",
      "crm-message-bus": "/crm-message-bus/static-1.43875",
      "crm-search-service-types": "/crm-search-service-types/static-1.1496",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5692",
      "customer-data-communicator": "/customer-data-communicator/static-1.46452",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41082",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13391",
      "customer-data-properties": "/customer-data-properties/static-1.52753",
      "customer-data-rte": "/customer-data-rte/static-1.33723",
      "draft-plugins": "/draft-plugins/static-2.22222",
      "file-manager-components": "/file-manager-components/static-1.24620",
      "trellis-theming": "/trellis-theming/static-1.1335",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7254",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8281",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19083",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11428",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1288",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8463",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18453",
      "universal-associations-select": "/universal-associations-select/static-1.11439",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2116",
      "wootric-nps": "/wootric-nps/static-1.7232",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4083",
      "property-translator": "/property-translator/static-1.5742",
      "segments-query-core": "/segments-query-core/static-1.1785",
      "bender-build-tools": "/bender-build-tools/static-1.3452",
      "stylex-utils": "/stylex-utils/static-1.149",
      "opentelemetry-web": "/opentelemetry-web/static-1.15",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.66",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10710",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10708",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5359",
      "base-ui": "/base-ui/static-1.23",
      "react-day-picker": "/react-day-picker/static-1.11",
      "tanstack-virtual": "/tanstack-virtual/static-1.39",
      "react-dnd-compat": "/react-dnd-compat/static-1.4975",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.539",
      "copilot-toolkit": "/copilot-toolkit/static-1.11943",
      "audio-components": "/audio-components/static-1.6421",
      "ContentUtils": "/ContentUtils/static-1.69237",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29889",
      "FileManagerImages": "/FileManagerImages/static-1.37771",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1599",
      "html-to-image": "/html-to-image/static-1.62",
      "immerable": "/immerable/static-1.4505",
      "react-colorpicker": "/react-colorpicker/static-2.10575",
      "ui-universal-auth": "/ui-universal-auth/static-1.9504",
      "video-components": "/video-components/static-1.14244",
      "video-data-lib": "/video-data-lib/static-1.35900",
      "video-embed": "/video-embed/static-1.36734",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.694",
      "chatspot-core": "/chatspot-core/static-1.23302",
      "superstore": "/superstore/static-1.5120",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9052",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29408",
      "card-properties-lib": "/card-properties-lib/static-1.45116",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37892",
      "crm-actions": "/crm-actions/static-1.6710",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44720",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10037",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8448",
      "customer-data-tracking": "/customer-data-tracking/static-1.7230",
      "hs-resources": "/hs-resources/static-1.553",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "framework-data-table": "/framework-data-table/static-2.12649",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10212",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1784",
      "calling-error-reporting": "/calling-error-reporting/static-1.31689",
      "calling-internal-common": "/calling-internal-common/static-1.31682",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6896",
      "crm_data": "/crm_data/static-4.92962",
      "customer-data-content": "/customer-data-content/static-1.27869",
      "draft-content-plugins": "/draft-content-plugins/static-1.28979",
      "draft-convert": "/draft-convert/static-2.81",
      "draft-extend": "/draft-extend/static-3.84",
      "draft-js": "/draft-js/static-5.86",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24794",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25073",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19075",
      "integration-settings-components": "/integration-settings-components/static-1.16306",
      "integrations-lib": "/integrations-lib/static-1.17180",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5971",
      "laboratory-lib": "/laboratory-lib/static-3.7513",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8126",
      "nav-meta": "/nav-meta/static-1.30572",
      "onboarding-scopes": "/onboarding-scopes/static-1.6813",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6896",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12409",
      "quotes-client-types": "/quotes-client-types/static-1.38970",
      "reference-resolvers": "/reference-resolvers/static-1.8542",
      "rich-text-lib": "/rich-text-lib/static-1.20389",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4208",
      "sequences-lib": "/sequences-lib/static-1.8607",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11508",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9438",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9452",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10632",
      "user-context": "/user-context/static-1.5471",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6882",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23517",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13529",
      "events-data-lib": "/events-data-lib/static-1.608",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.5075",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4258",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1367",
      "onboarding-tours": "/onboarding-tours/static-1.17215",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14561",
      "segments-client-types": "/segments-client-types/static-1.11740",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
      "ui-addon-teams": "/ui-addon-teams/static-1.21963",
      "calling-global-api": "/calling-global-api/static-1.65812",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67194",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59488",
      "commerce-products-lib": "/commerce-products-lib/static-1.10656",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4053",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4607",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4384",
      "external-options-client-types": "/external-options-client-types/static-1.4377",
      "formula-editor": "/formula-editor/static-1.14855",
      "google-libphonenumber": "/google-libphonenumber/static-1.46",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4461",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.995",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3944",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49801",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4219",
      "property-value-citations": "/property-value-citations/static-1.3367",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.233",
      "smart-property-lib": "/smart-property-lib/static-1.8414",
      "tiered-pricing": "/tiered-pricing/static-1.2048",
      "topics-actions-lib": "/topics-actions-lib/static-1.531",
      "trial-components-library": "/trial-components-library/static-1.14200",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11332",
      "zustand": "/zustand/static-1.86",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1882",
      "video-components-external": "/video-components-external/static-1.12242",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.373",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7159",
      "persist-promise": "/persist-promise/static-1.4062",
      "content-media-capture": "/content-media-capture/static-1.5560",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.26291",
      "knowledge-content-types": "/knowledge-content-types/static-1.8699",
      "payment-link-components": "/payment-link-components/static-1.24246",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10231",
      "call-summary": "/call-summary/static-1.40502",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10856",
      "merchandise-lib": "/merchandise-lib/static-1.279",
      "purchase-motions-components": "/purchase-motions-components/static-1.6487",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10285",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "magpie-lib": "/magpie-lib/static-1.5799",
      "magpie-types": "/magpie-types/static-1.5259",
      "simple-logging-lib": "/simple-logging-lib/static-1.3410",
      "cms-field-types": "/cms-field-types/static-1.5171",
      "content-icons-ui": "/content-icons-ui/static-1.2410",
      "underscore": "/underscore/static-1.8",
      "nudge-client-utils": "/nudge-client-utils/static-1.3230",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1300",
      "social-insights-client-types": "/social-insights-client-types/static-1.22729",
      "outpost": "/outpost/static-1.4500",
      "markdown-it": "/markdown-it/static-1.6",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6946",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46833",
      "enrichment-lib": "/enrichment-lib/static-1.617",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4623",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20317",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19374",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11142",
      "customer-data-associations": "/customer-data-associations/static-1.7690",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.240",
      "reporting-data": "/reporting-data/static-1.68997",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.5107",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3803",
      "crm_universal": "/crm_universal/static-1.22556",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9675",
      "content-embed-lib": "/content-embed-lib/static-1.7699",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.13280",
      "remote-dom": "/remote-dom/static-1.5",
      "remote-ui": "/remote-ui/static-1.72",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5988",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17989",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3371",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14595",
      "redux-observable": "/redux-observable/static-1.76",
      "ReduxMessenger": "/ReduxMessenger/static-2.10732",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.1018",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.9043",
      "data-token-picker": "/data-token-picker/static-1.16965",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8464",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6057",
      "navigation-messaging": "/navigation-messaging/static-1.8262",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19350",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18468",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1282",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2123",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7233",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.10041",
      "growth-data-modal": "/growth-data-modal/static-1.5971",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3425",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2788",
      "navigation-components": "/navigation-components/static-1.18935",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5430",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8013",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6806",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11401",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.2177",
      "commerce-permissions": "/commerce-permissions/static-1.1137",
      "products-iframe-lib": "/products-iframe-lib/static-1.8688",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11092",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10793",
      "sales-views-client-types": "/sales-views-client-types/static-1.4616",
      "bark-lib": "/bark-lib/static-1.16882",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.103",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6250",
      "react-codemirror": "/react-codemirror/static-1.11003",
      "data-agent-kit": "/data-agent-kit/static-1.727",
      "fsm": "/fsm/static-1.4114",
      "policy-lib": "/policy-lib/static-1.7166",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15689",
      "hubs-service-types": "/hubs-service-types/static-1.1621",
      "purchase-motions-api": "/purchase-motions-api/static-1.6490",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.860",
      "breeze-engine-core": "/breeze-engine-core/static-1.1160",
      "highlight.js": "/highlight.js/static-1.87",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13364",
      "content-media-compositions": "/content-media-compositions/static-2.17371",
      "idb-keyval": "/idb-keyval/static-1.52",
      "media-bridge-lib": "/media-bridge-lib/static-1.19481",
      "fix-webm-duration": "/fix-webm-duration/static-1.31",
      "notification-sounds": "/notification-sounds/static-1.4784",
      "seat-types-lib": "/seat-types-lib/static-1.822",
      "ui-addon-opt": "/ui-addon-opt/static-4.8715",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6703",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5442",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3890",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19660",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9476",
      "reactive-lib": "/reactive-lib/static-1.1079",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2987",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3306",
      "whisper-core-api": "/whisper-core-api/static-1.7429",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38102",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13513",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55915",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22294",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18939",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72880",
      "data-agent-test-utils": "/data-agent-test-utils/static-1.210",
      "data-agent-utils": "/data-agent-utils/static-1.679",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10457",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23975",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.8072",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6363",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15653",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5464",
      "qrcode-generator": "/qrcode-generator/static-1.77",
      "reporting-client-types": "/reporting-client-types/static-1.2731",
      "react-flip-move": "/react-flip-move/static-1.79",
      "FireAlarmUi": "/FireAlarmUi/static-1.4756",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4421",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11464",
      "association-settings-lib": "/association-settings-lib/static-1.11115",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58828",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.349",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.13260",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13483",
      "ExportDialog": "/ExportDialog/static-6.10740",
      "final-form": "/final-form/static-1.79",
      "property-management-iframe": "/property-management-iframe/static-1.14240",
      "property-usages-lib": "/property-usages-lib/static-1.5871",
      "reactflow": "/reactflow/static-1.72",
      "simple-data-table": "/simple-data-table/static-1.3613",
      "used-in-list-lib": "/used-in-list-lib/static-1.7328",
      "visual-association": "/visual-association/static-1.6255",
      "highcharts": "/highcharts/static-8.112",
      "reporting-visualizations": "/reporting-visualizations/static-1.61071",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4277",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.568",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1580",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.68",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1130",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.268",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.606",
      "slack-ui-library": "/slack-ui-library/static-1.10758",
      "ai-rendering-library": "/ai-rendering-library/static-1.11199",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8419",
      "breeze-engine-ui-devtools": "/breeze-engine-ui-devtools/static-1.256",
      "copilot-plugins": "/copilot-plugins/static-1.11915",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1572",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1742",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.584",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4283",
      "ui-tool-access": "/ui-tool-access/static-1.10515",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2621",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2816",
      "user-context-client": "/user-context-client/static-1.4869",
      "nest": "/nest/static-1.596",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36954",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16460",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4867",
      "storybook-react": "/storybook-react/static-1.41",
      "academy-common-lib": "/academy-common-lib/static-1.15149",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.41174",
      "settings-ui-lib": "/settings-ui-lib/static-1.12883",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7616",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55931",
      "commerce-products-api": "/commerce-products-api/static-1.2758",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57989",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103558",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81601",
      "one-click-checkout": "/one-click-checkout/static-1.538",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7931",
      "reporting-ui-components": "/reporting-ui-components/static-2.66266",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15302",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19377",
      "stripe-connect-js": "/stripe-connect-js/static-1.78",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9892",
      "hub-http-contrib": "/hub-http-contrib/static-1.3388",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5563",
      "nested-table": "/nested-table/static-1.596",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23293",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3625",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.367",
      "property-management-common": "/property-management-common/static-1.6528",
      "d3": "/d3/static-1.7",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.839",
      "global-styles-ai-lib": "/global-styles-ai-lib/static-1.250",
      "marketplace-embed-ba": "/marketplace-embed-ba/static-1.719",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.42167",
      "reporting-snowflake": "/reporting-snowflake/static-1.57613",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.590",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16676",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7971",
      "academy-service-client": "/academy-service-client/static-1.4052",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4754",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7702",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.899",
      "price-books-api": "/price-books-api/static-1.1830",
      "price-books-components": "/price-books-components/static-1.1888",
      "property-description-translator": "/property-description-translator/static-1.4185",
      "ramp-editor": "/ramp-editor/static-1.982",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3878",
      "totals-ui-components": "/totals-ui-components/static-1.24384",
      "checkout-sdk": "/checkout-sdk/static-3.24476",
      "payment-method-components": "/payment-method-components/static-1.7206",
      "touchless-buying-components": "/touchless-buying-components/static-1.6344",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
      "reporting-plugins": "/reporting-plugins/static-1.10834",
      "reporting-reports": "/reporting-reports/static-1.68673",
      "edison-service-client-types": "/edison-service-client-types/static-1.758",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10897",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18252",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20845",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8377",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.508",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1039",
      "marketplace-embed": "/marketplace-embed/static-1.23016",
      "marketplace-ui-install": "/marketplace-ui-install/static-1.831",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15015",
      "dashboard-lib": "/dashboard-lib/static-1.83003",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9070",
      "ContentData": "/ContentData/static-1.69312",
      "line-items-api": "/line-items-api/static-1.1167",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4069",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.856",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4352",
      "company-details-components": "/company-details-components/static-1.6567",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16093",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3815",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10508",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3588",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5708",
      "apps-service-types": "/apps-service-types/static-1.4067",
      "oauth-service-types": "/oauth-service-types/static-1.4594",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1261",
      "connections-embed-lib": "/connections-embed-lib/static-1.1589",
      "fail-safe": "/fail-safe/static-1.317",
      "ai-studio-lib": "/ai-studio-lib/static-1.12523",
      "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.562",
      "ui-product-approvals": "/ui-product-approvals/static-1.29366",
      "redux-actions": "/redux-actions/static-3.71",
      "advanced-menus-core": "/advanced-menus-core/static-1.15650",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12507",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34941",
      "company-details-service-types": "/company-details-service-types/static-1.4303",
      "pricing-pages-api": "/pricing-pages-api/static-1.15958",
      "copilot-messaging": "/copilot-messaging/static-1.2193",
      "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.268",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15649",
      "simple-menus-lib": "/simple-menus-lib/static-1.17166"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30826",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};